import { createApp } from "vue";
import App from "./App.vue";
import { Domyland } from "@domyland-shared/mini-app-sdk";

Domyland.init();

createApp(App).mount("#app");
